import { render } from "./PlatformProvider.vue?vue&type=template&id=2ff42cef"
import script from "./PlatformProvider.vue?vue&type=script&lang=js"
export * from "./PlatformProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__